import { useEffect } from 'react';

import { ConfirmationDialog } from 'components';
import { useTranslation } from 'libs/i18n';
import { DialogProps, Stack } from 'libs/ui';

import { Field, Submit, useFormContext } from '../emailForm';

export interface FormContentProps
  extends Pick<DialogProps, 'isOpen' | 'onClose'> {
  submitLoading?: boolean;
}

export const FormContent = ({
  submitLoading,
  ...dialogProps
}: FormContentProps) => {
  const { t } = useTranslation();
  const { resetForm } = useFormContext();

  useEffect(() => {
    if (!dialogProps.isOpen) {
      resetForm();
    }
  }, [dialogProps.isOpen, resetForm]);

  return (
    <ConfirmationDialog
      {...dialogProps}
      headerCentered
      buttonConfirm={Submit}
      confirmButtonLabel={t('common.save')}
      loading={submitLoading}
      maxWidth="sm"
      subtitle={t('client.dialogChangeEmail.subtitle')}
      title={t('client.dialogChangeEmail.title')}
      onBack={dialogProps.onClose}
    >
      <Stack spacing={12}>
        <Field.Text
          showRequiredMark
          autoComplete="off"
          label={t('client.dialogChangeEmail.reason.label')}
          name="reason"
          placeholder={t('client.dialogChangeEmail.reason.placeholder')}
        />
        <Field.Text
          helperTextAbsolute
          showRequiredMark
          autoComplete="off"
          label={t('client.dialogChangeEmail.email.label')}
          name="email"
          placeholder={t('client.dialogChangeEmail.email.placeholder')}
        />
      </Stack>
    </ConfirmationDialog>
  );
};
